import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { PartesService } from '../../services/partes.services';

/**
 * Generated class for the FichadaEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-fichada-edit',
  templateUrl: 'fichada-edit.html',
})
export class FichadaEditPage {
  fichada = {Fecha : null, Ficha : null, Nombre : null, Entradas : [{hora : '',latitud : 0, longitud : 0}], Salidas : [{hora : '',latitud : 0, longitud : 0}]};
  constructor(public navCtrl: NavController, public navParams: NavParams, public partesService : PartesService) {
    this.fichada = navParams.data.item;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad FichadaEditPage');
  }
  GuardarFichada(){
    
    let i : number;
    let j : number;
    for( i = 0; i < this.fichada.Entradas.length; i++ ) {
      if(this.fichada.Entradas[i].hora == '00:00:00'){
        this.fichada.Entradas.splice(i,1);
      }
    }

    for( j = 0; j < this.fichada.Salidas.length; j++ ) {
      if(this.fichada.Salidas[j].hora == '00:00:00'){
        this.fichada.Salidas.splice(j,1);
      }
    }

    this.partesService.editFichada(this.fichada,this.fichada.Fecha,this.fichada.Ficha);
    this.navCtrl.pop();

  }
}



// WEBPACK FOOTER //
// ./src/pages/fichada-edit/fichada-edit.ts